import { createContext, useEffect, useState } from "react"
import { Theme } from "../hooks/useTheme"

interface ErliaThemeContextType {
  theme: Theme
  setTheme: (theme: Theme) => void
  toggleTheme: () => void
}

const ErliaThemeContext = createContext<ErliaThemeContextType | undefined>(undefined)

type ErliaThemeProviderProps = {
  children: React.ReactNode
}

export function ErliaThemeProvider({
  children,
}: ErliaThemeProviderProps) {
  const [theme, setTheme] = useState<Theme>(() => {
    return 'custom'
  })

  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('erlia-theme', theme)
    }
  }, [theme])

  useEffect(() => {
    const root = window.document.documentElement
    
    root.classList.remove('light', 'custom')
    
    root.classList.add(theme)
    
    if (theme === 'custom') {
      root.classList.add('custom-theme')
    } else {
      root.classList.remove('custom-theme')
    }
  }, [theme])

  const toggleTheme = () => {
    setTheme(current => {
      if (current === 'light') return 'custom'
      return 'light'
    })
  }

  const value: ErliaThemeContextType = {
    theme,
    setTheme,
    toggleTheme
  }

  return (
    <ErliaThemeContext.Provider value={value}>
      {children}
    </ErliaThemeContext.Provider>
  )
}

export { ErliaThemeContext }
